<!-- Kullanıcı Kesin olarak seçtiği talep türünün, ürün listesini basıldığı ve ürün seçtiği ekrandır.
Burada talep türü dynamic component ile basılmıştır. -->

<!--Buralar test amaçlı eklenen dataları görmek için eklendi-->
<!--<button [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (loading | async)}" class="btn btn-success" (click)="btnTestShoppingCards()">Test</button>-->

<!-- <div>

	<table>
		<tr *ngFor="let product of (shoppingCartItems$ | async)" style="color:red">
			<td>{{product.id}}</td>
			<td>{{product.name}}</td>
			<td>{{product.orderedQty}}</td>
			<td>{{product.variationId}}</td>
		</tr>
	</table>

</div> -->

<div class="row">
	<div class="col-xl-12 col-lg-12 order-lg-1 order-xl-1">
		<div class="kt-portlet">
			<div class="kt-potlet__body">
				<div class="card-body" style="padding: 30px;">
					<div class="alert alert-solid-brand alert-bold" role="alert" [hidden]="!infoHide" *ngIf="(userFormAuthorization$ | async)?.isOrderByExpirationDate || (userFormAuthorization$ | async)?.isOrderBySpecialCode">
						<div class="alert-icon"><i class="flaticon-warning"></i></div>
						<div class="alert-text">
							{{ 'FE.ORDER.FORMS.INFOALERTS.COMMON.PRIORITYVARIATION' | localize }}
							<i class="la la-question-circle fa-2x" ngbPopover="{{ 'FE.ORDER.FORMS.INFOALERTS.COMMON.WHATISVARIATION.SUBHEADER' | localize }}" popoverTitle="{{ 'FE.ORDER.FORMS.INFOALERTS.COMMON.WHATISVARIATION.HEADER' | localize }}" placement="bottom"></i>
						</div>
						<div class="alert-close">
							<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="btnInfoHide()">
								<span aria-hidden="true"><i class="la la-close"></i></span>
							</button>
						</div>
					</div>

					<!-- Bu template, Transfer islemi gibi, talep yapilan depodan once gelecek olan component tipleri icin kullanilir. -->
					<ng-template AppCmpViewTop></ng-template>

					<div class="form-group row" *ngIf="(componentName | async) != 'FromReceiveWarehouseComponent'">
						<label class="col-lg-2 offset-lg-3 col-form-label">{{ uiLabelsWarehouse | localize }}<i class="text-danger">*</i></label>
						<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
							<mat-select class="form-control"
										placeholder="{{ uiLabelsWarehouse | localize }}"
										[(ngModel)]="selectedRequestedWareHouseObj"
										name="requestWarehouse"
										(selectionChange)="onChangeRequestedWareHouse()"
										required>
								<mat-option [value]="-1">{{ 'FE.ORDER.FORMS.COMBOBOX.WAREHOUSE.DEFAULTITEM' | localize }}</mat-option>
								<mat-option *ngFor="let rWareHouse of (requestedWarehouseList | async)"
											[value]="rWareHouse">
									{{rWareHouse.name}}
								</mat-option>
							</mat-select>

							<!--<div *ngIf="requestWarehouse.invalid && (requestWarehouse.dirty || requestWarehouse.touched)">
				<div *ngIf="selectedRequestedWareHouseObj.errors.required">
					Bu Alan Boş Bırakılamaz
				</div>
			</div>-->

							<span *ngIf="(isRequiredRequestedWareHouseMessage | async)" class="help-block" style="color: tomato;">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</span>
						</div>
					</div>
					<!-- ngTemplate içerisinde ki alana seçilen talep tirinin olduğu component ts tarafında dynamic oalrak ekrana basılıyor -->
					<ng-template AppCmpView></ng-template>

					<div class="form-group row">

						<!-- Teslimat Tipi Combosu -->
						<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.SHIPMENTTYPE' | localize }}</label>
						<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
							<mat-select class="form-control"
										placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.SHIPMENTTYPE' | localize }}"
										[(ngModel)]="selectedShipmentType"
										required>
								<mat-option *ngFor="let shipmentType of (formShipmentTypes | async)" [value]="shipmentType.id">{{shipmentType.localizationKey | localize}}</mat-option>
							</mat-select>
						</div>
					</div>
					<div class="form-group row" *ngIf="(userFormAuthorization$ | async)?.isOrderDamagedProduct">
						<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.PRODUCTDAMAGESTATUS' | localize }}</label>
						<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
							<mat-select class="form-control"
										placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.PRODUCTDAMAGESTATUS' | localize }}"
										[(ngModel)]="orderDamageStatusType"
										(selectionChange)="onChangeCmbOrderDamageStatus()"
										required>
								<!-- <mat-option value="0">Varyasyon Tipini Seçiniz</mat-option> -->
								<!--<mat-option [value]="1">Hasarlı</mat-option>
								<mat-option [value]="2">Hasarsız</mat-option>-->
								
								<mat-option *ngFor="let damageStatus of (damageStatuses | async)" [value]="damageStatus.id">{{damageStatus.localizationKey | localize}}</mat-option>

							</mat-select>
						</div>
					</div>
					<div class="form-group row" *ngIf="(userFormAuthorization$ | async)?.isOrderBySpecialCode && !(userFormAuthorization$ | async)?.isOrderByExpirationDate">
						<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.SPECIALCODES' | localize }}</label>
						<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
							<mat-select class="form-control"
										placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.SPECIALCODES' | localize }}"
										[(ngModel)]="selectedSpecialCodeVariationCode"
										(selectionChange)="onChangeSpecialCode()"
										required>
								<mat-option [value]="'-1'">{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.SELECTEDALL' | localize }}</mat-option>
								<mat-option *ngFor="let specialCode of (specialCodes | async)"
											[value]="specialCode">{{specialCode}}</mat-option>
							</mat-select>
						</div>
					</div>
					
				
					<!-- Talep Formu Aciklama Alani -->
					<div class="form-group row">
						<label class="col-lg-2 offset-lg-3 col-form-label">Açıklama</label>
						<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
							<textarea  class="form-control" [(ngModel)]="comment" style="width: 100%;" cols="10" rows="3" placeholder="Açıklama"></textarea>
						</div>
					</div>

					
					<!--<button (click)="btnTest()">Test</button>-->
					<ng-container *ngIf="(userFormAuthorization$ | async)?.isOrderByBusinessUnit">
					<hr >
						<div class="form-group row">
							<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.BUSINESSUNIT' | localize }}</label>
							<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
								<mat-select class="form-control"
											placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.BUSINESSUNIT' | localize }}"
											[(ngModel)]="selectedBusinessUnitId"
											(selectionChange)="onChanceBusinessUnit()"
											required>
									<mat-option [value]="-1">{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.SELECTEDALL' | localize }}</mat-option>
									
									<mat-option *ngFor="let assignedBusinessUnit of (assignedBusinessUnits| async)"
												[value]="assignedBusinessUnit.productAttributeId">{{assignedBusinessUnit.name}}</mat-option>
								</mat-select>

								
							</div>
						</div>
						<div class="form-group row">
							<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.BRAND' | localize }}</label>
							<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
								<mat-select class="form-control"
											placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.BRAND' | localize }}"
											[(ngModel)]="selectedBrandUnitId"
											(selectionChange)="onChanceBrandId()"
											required>
									<mat-option [value]="-1">{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.SELECTEDALL' | localize }}</mat-option>
									<mat-option *ngFor="let brandsByBusinessUnit of (brandsByBusinessUnits | async)"
												[value]="brandsByBusinessUnit.id">{{brandsByBusinessUnit.name}}</mat-option>
								</mat-select>
							</div>
						</div>
					</ng-container>
					<div [hidden]="!(isproductList | async)">
						<!--<div [hidden]="(totalCount$ | async) < 1 && !keyword">-->
						<div class="row">

								<!-- Tahmini sevk maliyeti dugmesi -->
							<div *ngIf="isShowTotalShipmentPriceButton"  class="col-md-2">
							
								<button class="btn btn-primary" (click)="calculateShipmentPrice()">Tahmini Maliyet</button>
							</div>
							<div class="col-md-4 offset-md-8">
								<!--<mat-form-field>
					<input matInput #searchInput placeholder="Arama" [(ngModel)]="keyword" name="keyword"
						   class="mat-form-field mat-form-field-fluid">
					<mat-icon *ngIf="!keyword.length" matSuffix>search</mat-icon>
					<mat-icon *ngIf="keyword.length" class="clear" matSuffix (click)="clearSearch()">
						clear
					</mat-icon>
				</mat-form-field>-->
								<div class="kt-input-icon kt-input-icon--left">
									<input type="text" class="form-control mat-form-field mat-form-field-fluid" placeholder="{{ 'FE.PRODUCTGRID.PLACEHOLDERS.SEARCH' | localize }}" #searchInput [(ngModel)]="keyword" name="keyword">
									<span class="kt-input-icon__icon kt-input-icon__icon--left">
										<span><i class="la la-search"></i></span>
									</span>
								</div>
							</div>
						</div>
						<!--</div>-->

						
						<hr />
						<div class="row product-list" *ngFor="let productItem of (products$ | async)" [ngClass]="{'gridBorder': insufficienStockIndicator(productItem.id) == true}">



							<div class="col-md-1 kt-margin-b-10-tablet-and-mobile">
								<a href="javascript:void(0)" (click)="openProductImage(productItem.kod, productItem.name)">
									<img photoUrl class="product-image" width="100%" [attr.src]="getPhotoUrl(productItem.kod)" alt="">
								</a>
							</div>
							<div class="col-md-8 kt-margin-b-10-tablet-and-mobile">
								<div class="justify-content-center align-items-center">
									<a class="kt-widget5__title w-500"
									   [ngClass]="{'inputBorder': insufficienStockIndicator(productItem.id) == true}">{{productItem.kod}}</a>
									<p class="kt-widget5__desc m-0"
									   [ngClass]="{'inputBorder': insufficienStockIndicator(productItem.id) == true}">{{productItem.name}}</p>
									<div class="kt-widget5__info">
										<span class="kt-font-info">{{productItem.businessUnitName}}</span>
										<span> - </span>
										<span class="kt-font-info w-500">{{productItem.marka}}</span>
										
									</div>
									<div class="kt-widget5__info">
										<!--WMS tagları-->
										<span class="kt-badge kt-badge--success kt-badge--inline" *ngIf="productItem.wmsTip">
											{{productItem.wmsTip ? productItem.wmsTip : ''}}

										</span>
										<span *ngIf="productItem.wmsTip"> - </span>
										<!--WMS tagları-->
										<span class="kt-font-dark">{{ 'FE.PRODUCTGRID.LABELS.INTHEPACKAGE' | localize }}</span>
										<span> - </span>
										<span class="kt-font-dark w-500">{{productItem.boxQuantity}}</span>

										<!-- Palete sigan miktar -->
										
										<ng-container *ngIf="productItem.palletQuantity && productItem.palletQuantity > 0">
											<span class="kt-font-dark"> / {{ 'FE.PRODUCTGRID.LABELS.INTHEPALLET' | localize }}</span>
											<span> - </span>
											<span class="kt-font-dark w-500">{{productItem.palletQuantity}}</span>
										</ng-container>
										
										

									</div>
									<div class="kt-widget5__info">
										<span *ngIf="productItem.barcode" class="kt-widget5__desc w-500 text-danger">{{productItem.barcode}}</span>
										<span *ngIf="productItem.barcode && productItem.expirationDate"> - </span>
										<span *ngIf="productItem.expirationDate" class="kt-widget5__desc text-danger">{{productItem.expirationDate}}</span>
									</div>
								</div>
							</div>
							<!--<div class="col-md-1 kt-margin-b-10-tablet-and-mobile">
								<div class="text-center stock">
									<span class="kt-widget5__sales text-center">{{ 'FE.PRODUCTGRID.LABELS.INTHEPACKAGE' | localize }}</span><br />
									<span class="kt-widget5__number">{{productItem.boxQuantity}}</span>
								</div>
							</div>-->
							<div class="col-md-1 kt-margin-b-10-tablet-and-mobile">
								<ng-container *ngIf="productItem.subVariations.length < 1">
									<div class="text-center stock" [hidden]="!(isStokView | async)">
										<!--<span class="kt-widget5__votes text-center">Stok</span><br />-->
										<span class="kt-widget5__votes text-center">{{ 'FE.PRODUCTGRID.LABELS.STOCK' | localize }}</span><br />
										<span class="kt-widget5__number">{{productItem.stok}}</span>

									</div>
								</ng-container>

								<!--<ng-container *ngIf="productItem.subVariations.length > 0 ">-->
								<ng-container *ngIf="productItem.subVariations.length > 0 && !(userFormAuthorization$ | async)?.isOrderByExpirationDate">
									<div class="text-center stock" [hidden]="!(isStokView | async)">
										<!--<span class="kt-widget5__votes text-center">Stok</span><br />-->
										<span class="kt-widget5__votes text-center">{{ 'FE.PRODUCTGRID.LABELS.STOCK' | localize }}</span><br />
										 <span class="text-info">{{ 'FE.ALERTMESSAGES.STOCK.EXPIRATIONDATELOTMODAL.VARIATIONISREQUIRED' | localize }} </span> <!--Stok yazısı-->

									</div>
								</ng-container>


							</div>
							<!--<div class="col-md-1 kt-margin-b-10-tablet-and-mobile">
				<div class="text-center">
					<span class="kt-widget5__votes">Skt/Lot</span><br />
					<ng-container *ngIf="!((userFormAuthorization$ | async)?.isOrderBySpecialCode)">
						<button class="btn btn-primary btn-sm btn-font-sm" placement="top" ngbTooltip="Skt/Lot Ekle" ngbTooltipClass="kt-tooltip" (click)="onClickOrderSKT(productItem)">+</button>
						<button class="btn btn-danger btn-sm btn-font-sm  kt-margin-l-10" placement="top" ngbTooltip="Skt/Lot Sil" ngbTooltipClass="kt-tooltip" [hidden]="setDisabledOrderQty(productItem) == false" (click)="onClickProductOrderQtyDelete(productItem)">-</button>
					</ng-container>
				</div>
			</div>-->
							<!--<div class="col-md-1 kt-margin-b-10-tablet-and-mobile sktLot">
				<div class="text-center">
					<span class="kt-widget5__votes">Skt/Lot</span><br />
					<ng-container *ngIf="!((userFormAuthorization$ | async)?.isOrderBySpecialCode)">
						<button class="btn btn-primary btn-sm btn-font-sm btn-block" placement="top" ngbTooltip="Skt/Lot Ekle" ngbTooltipClass="kt-tooltip" (click)="onClickOrderSKT(productItem)">Ekle</button>
						<button class="btn btn-danger btn-sm btn-font-sm  btn-block" placement="top" ngbTooltip="Skt/Lot Sil" ngbTooltipClass="kt-tooltip" [hidden]="setDisabledOrderQty(productItem) == false" (click)="onClickProductOrderQtyDelete(productItem)">Sil</button>
					</ng-container>
				</div>
			</div>-->

							<!--<div class="col-md-2 sktLot" *ngIf="productItem.subVariations.length > 0">-->
							<div class="col-md-2 sktLot" *ngIf="productItem.subVariations.length > 0 && !(userFormAuthorization$ | async)?.isOrderByExpirationDate">
								<div class="text-center stock margin-top-10">
									<button class="btn btn-primary btn-block btn-sm" (click)="btnSpecialCodeByVariation(productItem, productItem.id)">{{ 'FE.PRODUCTGRID.BUTTONS.SPECIALCODEVARIATION' | localize }}</button>
									<button class="btn btn-danger btn-block btn-sm" [hidden]="!btnCheckProductSave(productItem.id)" (click)="btnClearInCard(productItem.id)">{{ 'FE.PRODUCTGRID.BUTTONS.SPECIALCODEVARIATIONDELETE' | localize }}</button>
								</div>
							</div>

							<!--<div class="col-md-2 kt-margin-b-10-tablet-and-mobile sktLot stock" *ngIf="productItem.subVariations.length < 1">-->
							<div class="col-md-2 kt-margin-b-10-tablet-and-mobile sktLot stock" *ngIf="productItem.subVariations.length < 1">
								<!--<span class="kt-widget5__votes">Talep Adedi Giriniz.</span>-->
								<input class="form-control form-control-sm text-center"
									   [ngStyle]="{'border-color': productItem.orderedQty > 0 ? 'blue': ''}"
									   type="number"
									   name="orderedQty"
									   [(ngModel)]="productItem.orderedQty"
									   placeholder="Talep adedi giriniz."
									   (blur)="onBlurOrderQty(productItem)"
									   [disabled]="(userFormAuthorization$ | async)?.isOrderBySpecialCode ? false : setDisabledOrderQty(productItem)"
									   min="0"
									   oninput="this.value = Math.abs(this.value)">
								<!--<ng-container *ngIf="!((userFormAuthorization$ | async)?.isOrderBySpecialCode)">-->
								<!--<ng-container *ngIf="((userFormAuthorization$ | async)?.isOrderByExpirationDate) && !((userFormAuthorization$ | async)?.isOrderBySpecialCode)">-->
								<ng-container *ngIf="((userFormAuthorization$ | async)?.isOrderByExpirationDate)">
									<!--<button class="btn btn-primary btn-sm btn-font-sm btn-block" placement="top" ngbTooltip="Skt/Lot Ekle" ngbTooltipClass="kt-tooltip" (click)="onClickOrderSKT(productItem)">Skt/Lot Ekle</button>-->
									<button class="btn btn-primary btn-sm btn-font-sm btn-block" placement="top" ngbTooltip="{{ 'FE.PRODUCTGRID.BUTTONS.EXPIRATIONDATELOTADD' | localize }}" ngbTooltipClass="kt-tooltip" (click)="onClickOrderSKT(productItem)">{{ 'FE.PRODUCTGRID.BUTTONS.EXPIRATIONDATELOTADD' | localize }}</button>
									<button class="btn btn-danger btn-sm btn-font-sm btn-block" placement="top" ngbTooltip="{{ 'FE.PRODUCTGRID.BUTTONS.EXPIRATIONDATELOTDELETE' | localize }}" ngbTooltipClass="kt-tooltip" [hidden]="setDisabledOrderQty(productItem) == false" (click)="onClickProductOrderQtyDelete(productItem)">{{ 'FE.PRODUCTGRID.BUTTONS.EXPIRATIONDATELOTDELETE' | localize }}</button>
								</ng-container>
							</div>

						</div>
						<div [hidden]="(totalCount$ | async) < 10">
							<mat-spinner [diameter]="20" *ngIf="(loading$ | async)"></mat-spinner>
							<mat-paginator #paginatorBottom [pageSize]="10" [pageSizeOptions]="[3, 5, 10, 25]"
										   (page)="paginatorBottom.pageIndex = $event.pageIndex" [length]="totalCount$ | async"
										   [showFirstLastButtons]="true">
							</mat-paginator>
						</div>


					</div>
					<div class="text-center text-danger" *ngIf="(productNotFound | async)">

						<div [hidden]="!selectedRequestedWareHouseObj || selectedRequestedWareHouseObj == -1">
							Aranılan Kriterlere Uygun Ürün Bulunamadı.
						</div>
						
					</div>
					<div class="row margin-top-20" [hidden]="!selectedRequestedWareHouseObj || selectedRequestedWareHouseObj == -1 || (productNotFound | async)">
						<div class="col-md-12">
							<div class="pull-right">
								<div *ngIf="(componentName | async) == 'AddAddressToPersonCategoryComponent'; else notAddressComponent">
									<button [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':  (loading | async)}" class="btn btn-success" (click)="btnAddressOrderSave()">{{ 'FE.PRODUCTGRID.BUTTONS.ORDER' | localize }}</button>
								</div>
								<ng-template #notAddressComponent>
									<button [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (loading | async)}" class="btn btn-success" (click)="btnOrderSave()">{{ 'FE.PRODUCTGRID.BUTTONS.ORDER' | localize }}</button>
								</ng-template>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>


